export default "__VITE_ASSET__i7C5fh4G__"